import React, {useState} from 'react';

export interface ExpandableTextProps {
  children: string;
  maxLength?: number;
  className?: string;
  buttonClassName?: string;
  seeMoreText?: string;
  seeLessText?: string;
  preserveWhitespace?: boolean;
  disabled?: boolean;
}

export const ExpandableText: React.FC<ExpandableTextProps> = ({
  children,
  maxLength = 300,
  className = '',
  buttonClassName = '',
  seeMoreText = 'See more',
  seeLessText = 'See less',
  preserveWhitespace = true,
  disabled = false,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  // Return early if no text provided
  if (!children) return null;

  // Check if text needs truncation
  const shouldTruncate = children.length > maxLength && !disabled;

  // Get display text
  const displayText = shouldTruncate && !isExpanded ? children.substring(0, maxLength).trim() + '...' : children;

  // Base button classes
  const defaultButtonClasses = 'mt-2 text-blue-600 hover:text-blue-800 font-medium text-sm transition-colors cursor-pointer';
  const finalButtonClasses = buttonClassName ? `${defaultButtonClasses} ${buttonClassName}`.trim() : defaultButtonClasses;

  // Text container classes
  const textClasses = preserveWhitespace ? `${className} whitespace-pre-wrap`.trim() : className;

  return (
    <div>
      <div className={textClasses}>{displayText}</div>

      {shouldTruncate && (
        <button onClick={() => setIsExpanded(!isExpanded)} className={finalButtonClasses} type="button">
          {isExpanded ? seeLessText : seeMoreText}
        </button>
      )}
    </div>
  );
};
